var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * FontPicker
 *
 */
import React from 'react';
import Select from 'react-select';
export var FontFamilies = [
    'System',
    'Josefin Sans',
    'Lato',
    'Lora',
    'Merriweather',
    'Montserrat',
    'Noto Sans',
    'Noto Serif',
    'Open Sans',
    'Open Sans Condensed',
    'Oswald',
    'Overpass',
    'Playfair Display',
    'Poppins',
    'PT Sans',
    'PT Serif',
    'Raleway',
    'Roboto',
    'Roboto Condensed',
    'Roboto Slab',
    'Slabo 27px',
    'Ubuntu',
];
var FontPicker = /** @class */ (function (_super) {
    __extends(FontPicker, _super);
    function FontPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FontPicker.prototype.render = function () {
        var _a = this.props, value = _a.value, onChange = _a.onChange, style = _a.style;
        var fontFamilyOptions = FontFamilies.map(function (fontFamily) { return ({
            value: fontFamily,
            label: fontFamily,
        }); });
        return (_jsx(Select, { styles: {
                option: function (provided, state) { return (__assign(__assign({}, provided), { fontFamily: state.data.value === 'System' ? 'system-ui' : state.data.value })); },
                singleValue: function (provided, state) { return (__assign(__assign({}, provided), { fontFamily: state.data.value === 'System' ? 'system-ui' : state.data.value })); },
            }, style: style, value: fontFamilyOptions.find(function (fontFamily) { return fontFamily.value === value; }), onChange: onChange, isSearchable: true, placeholder: "Select a font...", options: fontFamilyOptions }));
    };
    return FontPicker;
}(React.PureComponent));
export default FontPicker;
